import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="Chicago">
              <h2>
                Custom Software Development in Chicago - Expertly Crafted for
                Your Business
              </h2>
            </div>
            <p>
              TekRevol is a top Chicago software development company offering
              full-stack development and consultancy solutions for enterprises
              that are looking for business excellence and a competitive edge.
              You can opt for our software development services and get a
              feature-rich digital solution for your business.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
